const { cloneObjectsPropertyState } = require('./utils')
const noop = () => {}

const createSetPositionCommand = ({
  objects,
  newValuesMap,
  optionalOldValuesMap,
  afterExecute = noop,
  afterUndo = noop
}) => {
  let oldValuesMap

  if (objects.length && Object.keys(newValuesMap).length) {
    oldValuesMap = cloneObjectsPropertyState(objects, 'position')
  }

  if (Object.keys(optionalOldValuesMap).length) {
    oldValuesMap = optionalOldValuesMap
  }

  return {
    affectsDirty: true,

    undo () {
      objects.forEach((object) => {
        object.position.copy(oldValuesMap[object.uuid])
      })

      afterUndo()
    },

    execute () {
      objects.forEach((object) => {
        object.position.copy(newValuesMap[object.uuid])
      })

      afterExecute()
    }
  }
}

module.exports = createSetPositionCommand
